import React from 'react';
import { motion } from 'framer-motion';
import ToutesFormations from '../../components/Admin/ToutesFormations';

const FormationsPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
    >
      <div className="h-32"></div>
      <ToutesFormations />
    </motion.div>
  );
};

export default FormationsPage;